const initialState = false;

const includeAnnotationsToggle = (state = initialState, action: any) => {
    switch (action.type) {
        case "SET_INCLUDE_ANNOTATIONS_TOGGLE":
            return action.payload;
        default:
            return state;
    }
}

export default includeAnnotationsToggle;